import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "@/constants/site";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee"
      className="group relative overflow-hidden border-y border-white/10 bg-gradient-to-r from-violet-950/40 via-[#0c0a14] to-violet-950/40 py-5"
      aria-label="Savoir-faire Pokebastos"
    >
      <div className="animate-marquee flex w-max items-center gap-8 pr-8 group-hover:[animation-play-state:paused]">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display whitespace-nowrap text-sm font-bold uppercase tracking-[0.2em] text-[#c8c4d8] sm:text-base">
              {item}
            </span>
            <Sparkle size={14} className="shrink-0 text-amber-300" aria-hidden="true" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#08070d] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#08070d] to-transparent" />
    </div>
  );
}
